export const trim = (value: string): string => value && value.trim();
export const filterString = (value: string, maxLength = 50): string =>
  value && value.trimStart().replace(/\s+/g, ' ').substring(0, maxLength);
export const onTypeFilterString = (maxLength: number) => (value: string) =>
  filterString(value, maxLength);
export const onTypeFilterAZ = (value: string) => value.replace(/[^a-z]+/gi, '');
